import { MapPin, Phone, MessageCircle, Clock, Instagram, Facebook } from 'lucide-react';
import { HERO_IMAGE } from '../data/catalog';
import { useSiteConfig } from '../utils/siteConfig';

export default function NossaLoja() {
  const { store } = useSiteConfig();
  const telHref = `tel:+55${store.phone.replace(/\D/g, '')}`;

  return (
    <main className="mx-auto max-w-5xl px-4 py-10 md:py-14" data-testid="store-page">
      <h1 className="font-serif text-3xl tracking-tight text-navy md:text-4xl">Nossa Loja</h1>
      <p className="mt-3 max-w-2xl leading-relaxed text-foreground/70">
        A {store.name} é uma loja tradicional no centro de Curitiba, há mais de 30 anos
        atendendo costureiras, alfaiates, estilistas, decoradores e apaixonados por tecidos.
      </p>
      <div className="mt-8 grid gap-8 md:grid-cols-2">
        <img
          src={HERO_IMAGE}
          alt={`Tecidos nobres da loja ${store.name}`}
          className="h-64 w-full rounded-2xl object-cover md:h-80"
          loading="lazy"
        />
        <div className="space-y-5 rounded-2xl border border-navy/10 bg-white p-6 text-sm">
          <p className="flex items-start gap-3">
            <MapPin className="mt-0.5 h-5 w-5 shrink-0 text-navy" />
            <span>
              <strong className="block text-navy">Endereço</strong>
              <span data-testid="store-address">{store.address}</span>
              <br />
              <span data-testid="store-city">{store.cityUf}</span>
            </span>
          </p>
          <p className="flex items-start gap-3">
            <Clock className="mt-0.5 h-5 w-5 shrink-0 text-navy" />
            <span>
              <strong className="block text-navy">Horário de atendimento</strong>
              <span className="whitespace-pre-line" data-testid="store-hours">{store.hours}</span>
            </span>
          </p>
          <p className="flex items-start gap-3">
            <Phone className="mt-0.5 h-5 w-5 shrink-0 text-navy" />
            <span>
              <strong className="block text-navy">Telefone</strong>
              <a href={telHref} className="hover:underline" data-testid="store-phone-link">{store.phone}</a>
            </span>
          </p>
          <p className="flex items-start gap-3">
            <MessageCircle className="mt-0.5 h-5 w-5 shrink-0 text-[#128C4B]" />
            <span>
              <strong className="block text-navy">WhatsApp</strong>
              <a href={`https://wa.me/${store.whatsappDigits}`} target="_blank" rel="noreferrer" className="hover:underline" data-testid="store-whatsapp-link">
                {store.whatsapp}
              </a>
            </span>
          </p>
          {store.attendanceNote && (
            <p className="rounded-xl bg-navy-light/50 p-3 text-xs leading-relaxed text-navy" data-testid="store-attendance-note">
              {store.attendanceNote}
            </p>
          )}
          {(store.instagram || store.facebook) && (
            <div className="flex flex-wrap gap-2 border-t border-navy/10 pt-4" data-testid="store-social-links">
              {store.instagram && (
                <a href={store.instagram} target="_blank" rel="noreferrer" data-testid="store-instagram-link" className="flex items-center gap-2 rounded-full border border-navy/20 px-4 py-2.5 text-xs font-semibold text-navy hover:bg-navy-light">
                  <Instagram className="h-4 w-4" /> Instagram
                </a>
              )}
              {store.facebook && (
                <a href={store.facebook} target="_blank" rel="noreferrer" data-testid="store-facebook-link" className="flex items-center gap-2 rounded-full border border-navy/20 px-4 py-2.5 text-xs font-semibold text-navy hover:bg-navy-light">
                  <Facebook className="h-4 w-4" /> Facebook
                </a>
              )}
            </div>
          )}
        </div>
      </div>
    </main>
  );
}
